if (!customElements.get('localization-form')) {
  customElements.define(
    'localization-form',
    class LocalizationForm extends HTMLElement {
      constructor() {
        super();
        this.header = document.querySelector('.header-wrapper');
        this.elements = {
          input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
          returnInput: this.querySelector('input[name="return_to"]'),
          button: this.querySelector('button.localization-form__select'),
          drawer: this.querySelector('.selector__dropdown[element-s-up]'),
          panel: this.querySelector('.disclosure__list-wrapper'),
          search: this.querySelector('input[name="country_filter"]'),
          closeButton: this.querySelector('.selector__close-button'),
          resetButton: this.querySelector('.country-filter__reset-button'),
          searchIcon: this.querySelector('.country-filter__search-icon'),
          liveRegion: this.querySelector('#sr-country-search-results'),
        };

        // Check for section-fetcher and wait for completion
        this.initializeForm();
      }

      // waitForSectionFetcher() {
      //   // Check if there are any section-fetcher elements in the document
      //   const sectionFetcher = this.querySelector('section-fetcher');

      //   if (!sectionFetcher) {
      //     // No section-fetcher found, initialize immediately
      //     this.initializeForm();
      //     return;
      //   }

      //   // Wait for all section-fetcher elements to complete
      //   let completedFetchers = 0;
      //   const totalFetchers = 1;

      //   const onSectionCached = (event) => {
      //     completedFetchers++;
      //     if (completedFetchers >= totalFetchers) {
      //       // All section-fetchers completed, initialize the form
      //       document.removeEventListener('section:cached', onSectionCached);
      //       this.initializeForm();
      //     }
      //   };

      //   // Listen for section:cached events
      //   document.addEventListener('section:cached', onSectionCached);

      //   // Also check if any section-fetchers are already completed
      //   const targetElement = document.getElementById(sectionFetcher.dataset.targetId);
      //   if (targetElement && targetElement.hasAttribute('data-loaded')) {
      //     completedFetchers++;
      //   }

      //   // If all are already completed, initialize immediately
      //   if (completedFetchers >= totalFetchers) {
      //     document.removeEventListener('section:cached', onSectionCached);
      //     this.initializeForm();
      //   }
      // }

      initializeForm() {
        if (this.closest('.header, .header-mobile, #header-group, .menu-drawer')) {
          this.init();
          return;
        }

        if (!theme.config.isTouch || Shopify.designMode) {
          Motion.inView(this, this.init.bind(this));
        } else {
          theme.initWhenVisible(this.init.bind(this));
        }
      }

      init() {
        if (this.dataset.localizationInitialized === 'true') return;
        this.dataset.localizationInitialized = 'true';

        this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
        this.addEventListener('keydown', this.onContainerKeyDown.bind(this));
        if (theme.config.mql) this.addEventListener('focusout', this.closeSelector.bind(this));
        const selectorOverlay = this.querySelector('#Selector-Overlay');
        if (selectorOverlay) selectorOverlay.addEventListener('click', this.hidePanel.bind(this));
        if (this.elements.button) this.elements.button.addEventListener('click', this.openSelector.bind(this));

        if (theme.config.mqlDesktop && this.getAttribute('activate-event') === 'hover') {
          const hoverEvents = ['focusin', 'mouseenter', 'mouseleave'];
          hoverEvents.forEach(event => this.addEventListener(event, this._hoverOpen.bind(this)));
        }

        if (this.elements.search) {
          this.elements.search.addEventListener('keyup', this.filterCountries.bind(this));
          this.elements.search.addEventListener('focus', this.onSearchFocus.bind(this));
          this.elements.search.addEventListener('blur', this.onSearchBlur.bind(this));
          this.elements.search.addEventListener('keydown', this.onSearchKeyDown.bind(this));
        }
        if (this.elements.closeButton) {
          this.elements.closeButton.addEventListener('click', this.hidePanel.bind(this));
        }
        if (this.elements.resetButton) {
          this.elements.resetButton.addEventListener('click', this.resetFilter.bind(this));
          this.elements.resetButton.addEventListener('mousedown', (event) => event.preventDefault());
        }

        this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
      }

      hidePanel() {
        if (this.elements.button) this.elements.button.setAttribute('aria-expanded', 'false');
        if (this.elements.drawer) this.elements.drawer.classList.remove('active');
        if (this.elements.search) {
          this.elements.search.value = '';
          this.filterCountries();
          this.elements.search.setAttribute('aria-activedescendant', '');
        }
        if (!theme.config.mql) removeTrapFocus(this.elements.button);
        document.body.classList.remove('overflow-hidden-mobile');
        const menuDrawer = document.querySelector('.menu-drawer');
        if (menuDrawer) menuDrawer.classList.remove('disclosure-selector-open');
        if (this.header) this.header.preventHide = false;
      }

      onContainerKeyDown(event) {
        const focusableItems = Array.from(this.querySelectorAll('a')).filter(
          (item) => !item.parentElement.classList.contains('hidden')
        );
        let focusedItemIndex = focusableItems.findIndex((item) => item === document.activeElement);
        let itemToFocus;

        switch (event.code.toUpperCase()) {
          case 'ARROWUP':
            event.preventDefault();
            itemToFocus =
              focusedItemIndex > 0 ? focusableItems[focusedItemIndex - 1] : focusableItems[focusableItems.length - 1];
            itemToFocus.focus();
            break;
          case 'ARROWDOWN':
            event.preventDefault();
            itemToFocus =
              focusedItemIndex < focusableItems.length - 1 ? focusableItems[focusedItemIndex + 1] : focusableItems[0];
            itemToFocus.focus();
            break;
        }

        if (!this.elements.search) return;

        setTimeout(() => {
          focusedItemIndex = focusableItems.findIndex((item) => item === document.activeElement);
          if (focusedItemIndex > -1) {
            this.elements.search.setAttribute('aria-activedescendant', focusableItems[focusedItemIndex].id);
          } else {
            this.elements.search.setAttribute('aria-activedescendant', '');
          }
        });
      }

      onContainerKeyUp(event) {
        event.preventDefault();
        if (!this.elements.button) return;

        switch (event.code.toUpperCase()) {
          case 'ESCAPE':
            if (this.elements.button.getAttribute('aria-expanded') == 'false') return;
            this.hidePanel();
            event.stopPropagation();
            this.elements.button.focus();
            break;
          case 'SPACE':
            if (this.elements.button.getAttribute('aria-expanded') == 'true') return;
            this.openSelector();
            break;
        }
      }

      getReturnToPath() {
        const pathname = window.location.pathname || '/';
        const search = window.location.search || '';
        const hash = window.location.hash || '';

        return `${pathname}${search}${hash}` || '/';
      }

      onItemClick(event) {
        event.preventDefault();
        const form = this.querySelector('form');
        const value = event.currentTarget.dataset.value;
        if (!form || !this.elements.input || !value) return;

        this.elements.input.value = value;

        if (!this.elements.returnInput) {
          this.elements.returnInput = document.createElement('input');
          this.elements.returnInput.type = 'hidden';
          this.elements.returnInput.name = 'return_to';
          form.appendChild(this.elements.returnInput);
        }

        this.elements.returnInput.value = this.getReturnToPath();

        HTMLFormElement.prototype.submit.call(form);
      }

      openSelector() {
        if (!this.elements.button || !this.elements.drawer) return;
        this.elements.button.focus();
        this.elements.drawer.classList.toggle('active');
        this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
        if (!document.body.classList.contains('overflow-hidden-tablet')) {
          document.body.classList.add('overflow-hidden-mobile');
        }
        if (theme.config.mql) {
          if (this.elements.search) this.elements.search.focus();
        } else {
          this.addEventListener('transitionend', () => {
            const containerToTrapFocusOn = this.querySelector('.slide__inner--mb');
            const focusElement = this.querySelector('.selector__close-button');
            trapFocus(containerToTrapFocusOn, focusElement);
          }, { once: true });

          this.elements.drawer.classList.add('drawer-slide-mb');
        }
        if (this.hasAttribute('data-prevent-hide')) {
          this.header.preventHide = true;
        }
        const menuDrawer = document.querySelector('.menu-drawer');
        if (menuDrawer) menuDrawer.classList.add('disclosure-selector-open');
      }

      _hoverOpen(event) {
        const value = event.type === 'mouseenter' || event.type === 'focusin';
        if (this.elements.drawer) this.elements.drawer.classList.toggle('active', value);
        if (this.elements.button) this.elements.button.setAttribute('aria-expanded', value);
        if (!document.body.classList.contains('overflow-hidden-tablet')) document.body.classList.toggle('overflow-hidden-mobile', value);
        if (this.hasAttribute('data-prevent-hide') && this.header) this.header.preventHide = value;
        const menuDrawer = document.querySelector('.menu-drawer');
        if (menuDrawer) menuDrawer.classList.toggle('disclosure-selector-open', value);
      }

      closeSelector(event) {
        if (!event || !this.contains(event.target) || !this.contains(event.relatedTarget)) {
          this.hidePanel();
        }
      }

      normalizeString(str) {
        return str
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
          .toLowerCase();
      }

      filterCountries() {
        const searchValue = this.normalizeString(this.elements.search.value);
        const popularCountries = this.querySelector('.popular-countries');
        const allCountries = this.querySelectorAll('a');
        let visibleCountries = allCountries.length;

        this.elements.resetButton.classList.toggle('hidden', !searchValue);

        if (popularCountries) {
          popularCountries.classList.toggle('hidden', searchValue);
        }

        allCountries.forEach((item) => {
          const countryName = this.normalizeString(item.querySelector('.country').textContent);
          if (countryName.indexOf(searchValue) > -1) {
            item.parentElement.classList.remove('hidden');
            visibleCountries++;
          } else {
            item.parentElement.classList.add('hidden');
            visibleCountries--;
          }
        });

        if (this.elements.liveRegion) {
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.countrySelectorSearchCount.replace('[count]', visibleCountries);
        }

        this.querySelector('.country-selector').scrollTop = 0;
        this.querySelector('.country-selector__list').scrollTop = 0;
      }

      resetFilter(event) {
        event.stopPropagation();
        this.elements.search.value = '';
        this.filterCountries();
        this.elements.search.focus();
      }

      onSearchFocus() {
        this.elements.searchIcon.classList.add('country-filter__search-icon--hidden');
      }

      onSearchBlur() {
        if (!this.elements.search.value) this.elements.searchIcon.classList.remove('country-filter__search-icon--hidden');
      }

      onSearchKeyDown(event) {
        if (event.code.toUpperCase() === 'ENTER') event.preventDefault();
      }
    }
  );
}

if (!customElements.get('dropdown-localization-component')) {
  customElements.define(
    'dropdown-localization-component',
    class DropdownLocalizationComponent extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        // Check for section-fetcher and wait for completion
        this.waitForSectionFetcher();
      }

      waitForSectionFetcher() {
        // Check if there are any section-fetcher elements in the document
        const sectionFetcher = this.querySelector('section-fetcher');

        if (!sectionFetcher) {
          // No section-fetcher found, initialize immediately
          this.initializeForm();
          return;
        }

        // Wait for all section-fetcher elements to complete
        let completedFetchers = 0;
        const totalFetchers = 1;

        const onSectionCached = (event) => {
          completedFetchers++;
          if (completedFetchers >= totalFetchers) {
            // All section-fetchers completed, initialize the form
            document.removeEventListener('section:cached', onSectionCached);
            this.initializeForm();
          }
        };

        // Listen for section:cached events
        document.addEventListener('section:cached', onSectionCached);

        // Also check if any section-fetchers are already completed
        const targetElement = document.getElementById(sectionFetcher.dataset.targetId);
        if (targetElement && targetElement.hasAttribute('data-loaded')) {
          completedFetchers++;
        }

        // If all are already completed, initialize immediately
        if (completedFetchers >= totalFetchers) {
          document.removeEventListener('section:cached', onSectionCached);
          this.initializeForm();
        }
      }

      initializeForm() {
        if (this.closest('.header, .header-mobile, #header-group, .menu-drawer')) {
          this.init();
          return;
        }

        if (!theme.config.isTouch || Shopify.designMode) {
          Motion.inView(this, this.init.bind(this));
        } else {
          theme.initWhenVisible(this.init.bind(this));
        }
      }

      init() {
        if (this.dataset.localizationInitialized === 'true') return;
        this.dataset.localizationInitialized = 'true';

        this.header = document.querySelector('.header-wrapper');
        this.elements = {
          button: this.querySelector('.dropdown-localization__button'),
          drawer: this.querySelector('.selector__dropdown[element-s-up]'),
          panel: this.querySelector('.disclosure__list-wrapper'),
        };

        this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
        if (theme.config.mql.matches) this.addEventListener('focusout', this.closeSelector.bind(this));
        if (this.elements.button) this.elements.button.addEventListener('click', this.openSelector.bind(this));

        // this.elements.drawer addEventListener intentionally omitted.
      }

      onContainerKeyUp(event) {
        event.preventDefault();

        switch (event.code.toUpperCase()) {
          case 'ESCAPE':
            if (this.elements.button.getAttribute('aria-expanded') == 'false') return;
            this.hidePanel();
            event.stopPropagation();
            this.elements.button.focus();
            break;
          case 'SPACE':
            if (this.elements.button.getAttribute('aria-expanded') == 'true') return;
            this.openSelector();
            break;
        }
      }

      openSelector() {
        if (!this.elements.button || !this.elements.drawer) return;
        this.elements.button.focus();
        this.elements.drawer.classList.toggle('active');
        this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());

        if (theme.config.mql) {
          if (this.elements.search) this.elements.search.focus();
        } else {

          this.addEventListener('transitionend', () => {
            const containerToTrapFocusOn = this.querySelector('.slide__inner--mb');
            const focusElement = this.querySelector('.selector__close-button');
            trapFocus(containerToTrapFocusOn, focusElement);
          }, { once: true });

          this.elements.drawer.classList.add('drawer-slide-mb');
        }
        if (this.hasAttribute('data-prevent-hide')) {
          if (this.header) this.header.preventHide = true;
        }
        const menuDrawer = document.querySelector('.menu-drawer');
        if (menuDrawer) menuDrawer.classList.add('disclosure-selector-open');
      }

      closeSelector(event) {
        event.preventDefault();
        if (!this.contains(event.target) || !this.contains(event.relatedTarget)) {
          this.hidePanel();
        }
      }

      hidePanel() {
        if (this.elements.button) this.elements.button.setAttribute('aria-expanded', 'false');
        if (this.elements.drawer) this.elements.drawer.classList.remove('active');
      }
    }
  );
}

if (!customElements.get('drawer-localization-component')) {
  customElements.define(
    'drawer-localization-component',
    class DrawerLocalizationComponent extends HTMLElement {
      constructor() {
        super();

        // Check for section-fetcher and wait for completion
        this.waitForSectionFetcher();
      }

      waitForSectionFetcher() {
        // Check if there are any section-fetcher elements in the document
        const sectionFetcher = this.querySelector('section-fetcher');

        if (!sectionFetcher) {
          // No section-fetcher found, initialize immediately
          this.initializeForm();
          return;
        }

        // Wait for all section-fetcher elements to complete
        let completedFetchers = 0;
        const totalFetchers = 1;

        const onSectionCached = (event) => {
          completedFetchers++;
          if (completedFetchers >= totalFetchers) {
            // All section-fetchers completed, initialize the form
            document.removeEventListener('section:cached', onSectionCached);
            this.initializeForm();
          }
        };

        // Listen for section:cached events
        document.addEventListener('section:cached', onSectionCached);

        // Also check if any section-fetchers are already completed
        const targetElement = document.getElementById(sectionFetcher.dataset.targetId);
        if (targetElement && targetElement.hasAttribute('data-loaded')) {
          completedFetchers++;
        }

        // If all are already completed, initialize immediately
        if (completedFetchers >= totalFetchers) {
          document.removeEventListener('section:cached', onSectionCached);
          this.initializeForm();
        }
      }

      initializeForm() {
        if (this.closest('.header, .header-mobile, #header-group, .menu-drawer')) {
          this.init();
          return;
        }

        if (!theme.config.isTouch || Shopify.designMode) {
          Motion.inView(this, this.init.bind(this));
        } else {
          theme.initWhenVisible(this.init.bind(this));
        }
      }

      init() {
        if (this.dataset.localizationInitialized === 'true') return;
        this.dataset.localizationInitialized = 'true';

        this.loadTemplate();

        this.header = document.querySelector('.header-wrapper');
        this.elements = {
          button: this.querySelector('.drawer-localization__button'),
          drawer: this.querySelector('.selector__dropdown[element-s-up]'),
          backButton: this.querySelector('.menu-drawer__back-button'),
        };
        this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
        // this.addEventListener('focusout', this.closeSelector.bind(this));
        if (this.elements.button) this.elements.button.addEventListener('click', this.openSelector.bind(this));
        if (this.elements.backButton) this.elements.backButton.addEventListener('click', this.closeSelector.bind(this));
        // this.elements.drawer addEventListener intentionally omitted.
      }

      loadTemplate() {
        const template = this.querySelector('template');
        if (template) {
          const templateContent = template.content.cloneNode(true);
          this.appendChild(templateContent);
        }
      }

      openSelector() {
        if (!this.elements.button || !this.elements.drawer) return;
        this.elements.button.focus();
        this.elements.drawer.classList.add('active');
      }

      onContainerKeyUp(event) {
        event.preventDefault();
        if (!this.elements.button) return;

        switch (event.code.toUpperCase()) {
          case 'ESCAPE':
            if (this.elements.button.getAttribute('aria-expanded') == 'false') return;
            this.hidePanel();
            event.stopPropagation();
            this.elements.button.focus();
            break;
          case 'SPACE':
            if (this.elements.button.getAttribute('aria-expanded') == 'true') return;
            this.openSelector();
            break;
        }
      }

      closeSelector(event) {
        event.preventDefault();
        if (!this.contains(event.target) || !this.contains(event.relatedTarget)) {
          this.hidePanel();
        }
      }

      hidePanel() {
        if (this.elements.button) this.elements.button.setAttribute('aria-expanded', 'false');
        if (this.elements.drawer) this.elements.drawer.classList.remove('active');
        document.body.classList.remove('overflow-hidden-mobile');
        const menuDrawer = document.querySelector('.menu-drawer');
        if (menuDrawer) menuDrawer.classList.remove('disclosure-selector-open');
      }
    }
  );
}

(() => {
  const summarySelector = [
    '.header__icon--localization details.details--dropdown-language > summary.dropdown-localization__button',
    '.header__icon--localization details.details-dropdown-language > summary.dropdown-localization__button',
    '.header-localization details.details--dropdown-language > summary.dropdown-localization__button',
    '.header-localization details.details-dropdown-language > summary.dropdown-localization__button',
    '.language-selector--only details.details--dropdown-language > summary.dropdown-localization__button',
    '.language-selector--only details.details-dropdown-language > summary.dropdown-localization__button',
    '.menu-drawer details.details--dropdown-language > summary',
    '.menu-drawer details.details-dropdown-language > summary'
  ].join(', ');

  const managedDetailsSelector = [
    '.header__icon--localization details.details--dropdown-language',
    '.header__icon--localization details.details-dropdown-language',
    '.header-localization details.details--dropdown-language',
    '.header-localization details.details-dropdown-language',
    '.language-selector--only details.details--dropdown-language',
    '.language-selector--only details.details-dropdown-language',
    '.menu-drawer details.details--dropdown-language',
    '.menu-drawer details.details-dropdown-language'
  ].join(', ');

  const headerDetailsSelector = [
    '.header [data-evo-header-localization] details.details--dropdown-language',
    '.header [data-evo-header-localization] details.details-dropdown-language',
    '.header localization-form[data-evo-header-localization] details.details--dropdown-language',
    '.header localization-form[data-evo-header-localization] details.details-dropdown-language',
    '.header .header__icon--localization details.details--dropdown-language',
    '.header .header__icon--localization details.details-dropdown-language',
    '.header .header-localization details.details--dropdown-language',
    '.header .header-localization details.details-dropdown-language'
  ].join(', ');

  const closeDetails = (details) => {
    const summary = details.querySelector('summary');

    details.removeAttribute('open');
    details.classList.remove('menu-opening');
    delete details.dataset.evoDrawerLanguageOpen;

    if (summary) summary.setAttribute('aria-expanded', 'false');
  };

  const getLocalizationRoots = (details) => {
    const roots = [
      details,
      details.closest('localization-form'),
      details.closest('[data-evo-header-localization]'),
      details.closest('.header__icon--localization'),
      details.closest('.header-localization')
    ].filter(Boolean);

    return Array.from(new Set(roots));
  };

  const isDrawerLocalizationDetails = (details) =>
    Boolean(details.closest('.menu-drawer, [data-evo-drawer-localization]'));

  const isElementVisible = (element) => {
    if (!element || !element.isConnected) return false;

    const style = window.getComputedStyle(element);
    if (
      style.display === 'none' ||
      style.visibility === 'hidden' ||
      style.opacity === '0' ||
      style.pointerEvents === 'none'
    ) {
      return false;
    }

    const rects = element.getClientRects();
    if (!rects || rects.length === 0) return false;

    return Array.from(rects).some((rect) => rect.width > 0 && rect.height > 0);
  };

  const isHiddenHeaderLocalizationDetails = (details) => {
    if (!details || isDrawerLocalizationDetails(details)) return false;
    if (!details.closest('.header')) return false;

    const root = details.closest('localization-form') || details.closest('[data-evo-header-localization]') || details;
    const summary = details.querySelector('summary');

    return !isElementVisible(root) || !isElementVisible(summary);
  };

  const setHeaderLocalizationHiddenState = (details, hidden) => {
    const roots = getLocalizationRoots(details);
    const focusables = details.querySelectorAll('summary, a, button, input, select, textarea, [tabindex]');

    roots.forEach((root) => {
      if (hidden) {
        root.dataset.evoLocalizationHidden = 'true';
        root.setAttribute('aria-hidden', 'true');
        try {
          root.inert = true;
        } catch (error) {}
      } else {
        delete root.dataset.evoLocalizationHidden;
        root.removeAttribute('aria-hidden');
        try {
          root.inert = false;
        } catch (error) {}
      }
    });

    focusables.forEach((node) => {
      if (hidden) {
        if (!node.hasAttribute('data-evo-original-tabindex') && node.hasAttribute('tabindex')) {
          node.setAttribute('data-evo-original-tabindex', node.getAttribute('tabindex'));
        }
        node.setAttribute('tabindex', '-1');
      } else if (node.hasAttribute('data-evo-original-tabindex')) {
        node.setAttribute('tabindex', node.getAttribute('data-evo-original-tabindex'));
        node.removeAttribute('data-evo-original-tabindex');
      } else if (node.getAttribute('tabindex') === '-1') {
        node.removeAttribute('tabindex');
      }
    });
  };

  const syncHeaderLocalizationVisibility = () => {
    document.querySelectorAll(headerDetailsSelector).forEach((details) => {
      const hidden = isHiddenHeaderLocalizationDetails(details);

      if (hidden) closeDetails(details);
      setHeaderLocalizationHiddenState(details, hidden);
    });
  };

  const scheduleHeaderLocalizationSync = () => {
    window.requestAnimationFrame(syncHeaderLocalizationVisibility);
  };

  const getHiddenHeaderLocalizationTarget = (target) => {
    if (!target || !target.closest) return null;
    const hiddenRoot = target.closest('.header [data-evo-localization-hidden="true"]');
    if (!hiddenRoot || hiddenRoot.closest('.menu-drawer')) return null;
    return hiddenRoot;
  };

  const isDrawerUtilityLanguageDetails = (details) =>
    details.matches('details.details--dropdown-language') &&
    Boolean(details.closest('.menu-drawer__utility-links'));

  const openDetails = (details) => {
    const summary = details.querySelector('summary');

    details.setAttribute('open', 'true');

    if (isDrawerUtilityLanguageDetails(details)) {
      details.classList.remove('menu-opening');
      details.dataset.evoDrawerLanguageOpen = 'true';
    } else {
      details.classList.add('menu-opening');
    }

    if (summary) {
      summary.setAttribute('aria-expanded', 'true');
      summary.focus();
    }
  };

  const closeOtherDetails = (currentDetails) => {
    document.querySelectorAll(managedDetailsSelector).forEach((details) => {
      if (details !== currentDetails) closeDetails(details);
    });
  };

  const onLocalizationSummaryClick = (event) => {
    const target = event.target;
    syncHeaderLocalizationVisibility();

    if (getHiddenHeaderLocalizationTarget(target)) {
      event.preventDefault();
      event.stopPropagation();
      return;
    }

    if (target && target.closest && target.closest('a[data-value]')) return;

    const summary = target && target.closest ? target.closest(summarySelector) : null;

    if (!summary) return;

    const details = summary.closest('details.details--dropdown-language');
    const fallbackDetails = summary.closest('details.details-dropdown-language');
    const activeDetails = details || fallbackDetails;
    if (!activeDetails) return;

    if (isHiddenHeaderLocalizationDetails(activeDetails)) {
      event.preventDefault();
      event.stopPropagation();
      closeDetails(activeDetails);
      setHeaderLocalizationHiddenState(activeDetails, true);
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    if (activeDetails.hasAttribute('open')) {
      closeDetails(activeDetails);
      return;
    }

    closeOtherDetails(activeDetails);
    openDetails(activeDetails);
  };

  const onDocumentClick = (event) => {
    const target = event.target;
    syncHeaderLocalizationVisibility();

    if (getHiddenHeaderLocalizationTarget(target)) {
      event.preventDefault();
      event.stopPropagation();
      return;
    }

    if (target && target.closest && target.closest('a[data-value]')) return;

    document.querySelectorAll(managedDetailsSelector).forEach((details) => {
      if (target && details.contains(target)) return;
      closeDetails(details);
    });
  };

  const onDocumentKeydown = (event) => {
    const key = event.code || event.key || '';
    if (key.toUpperCase() !== 'ESCAPE') return;

    document.querySelectorAll(managedDetailsSelector).forEach(closeDetails);
  };

  document.addEventListener('click', onLocalizationSummaryClick, true);
  document.addEventListener('click', onDocumentClick);
  document.addEventListener('keydown', onDocumentKeydown);
  document.addEventListener('DOMContentLoaded', scheduleHeaderLocalizationSync);
  window.addEventListener('load', scheduleHeaderLocalizationSync);
  window.addEventListener('resize', scheduleHeaderLocalizationSync);
  window.addEventListener('orientationchange', scheduleHeaderLocalizationSync);
  document.addEventListener('shopify:section:load', scheduleHeaderLocalizationSync);
  scheduleHeaderLocalizationSync();
})();
